import { PORTAL_MODE_CONFIG, usePortalModeStore } from "@stores/usePortalModeStore"
import { ModalsProvider } from "@mantine/modals"
import { TanStackDevtools } from "@tanstack/react-devtools"
import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools"
import { Outlet, useMatches } from "@tanstack/react-router"
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools"
import { RouterAuthSync } from "./RouterAuthSync"
import { useDocumentTitle } from "@mantine/hooks"
import { getPageTitle } from "@utils/types"

export const Root: React.FC = () => {

    const viewMode = usePortalModeStore((state) => state.viewMode)
    
    return (
        <main className={'w-screen h-screen overflow-hidden dark:scheme-dark'} key={viewMode}>
            <PortalDocumentTitle />
            <ModalsProvider
                modalProps={{
                    radius: 'lg',
                }}
            >
                <Outlet />
            </ModalsProvider>
            <RouterAuthSync />
            {/* <TanStackDevtools plugins={[
                    {
                        name: 'TanStack Query',
                        render: <ReactQueryDevtoolsPanel />,
                    },
                    {
                        name: 'TanStack Router',
                        render: <TanStackRouterDevtoolsPanel />,
                    },
                ]} 
            /> */}
        </main>
    )
}

const PortalDocumentTitle: React.FC = () => {
    const hostMode = usePortalModeStore((state) => state.hostMode)
    const matches = useMatches()
    const pageTitle = [...matches]
        .reverse()
        .map(getPageTitle)
        .find((title): title is string => Boolean(title))
    const portalTitle = PORTAL_MODE_CONFIG[hostMode].label

    useDocumentTitle(pageTitle ? `${pageTitle} | ${portalTitle}` : portalTitle)

    return null
}
